import { render, staticRenderFns } from "./WtTooltip.vue?vue&type=template&id=4a5108d8&scoped=true&lang=pug&"
import script from "./WtTooltip.vue?vue&type=script&lang=js&"
export * from "./WtTooltip.vue?vue&type=script&lang=js&"
import style0 from "./WtTooltip.vue?vue&type=style&index=0&id=4a5108d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5108d8",
  null
  
)

export default component.exports